import styled from "styled-components";

import { Flex } from "dash-ui";

export const CardContainer = styled(Flex)`
  border: 1px solid ${({ theme }) => theme.colors.n30};
  border-radius: ${({ theme }) => theme.space * 2}px;
  ${({ bgColor }: { bgColor?: string }) =>
    bgColor && `background-color: ${bgColor}`};
`;

export const ProfileBillingContainer = styled(Flex)`
  @media ${({ theme }) => theme.devices.mobile} {
  }
`;
